import React, { useEffect } from 'react'

import SaveTemplateButton from 'Pages/TemplateEdit/SaveTemplateButton'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { pageState } from 'Pages/TemplateEdit/recoil/state/page'
import { notifyParent } from 'Helpers/notifyParent'
import useRedirectorUrl from 'Hooks/useRedirectorUrl'
import aiIcon from '../../../img/aiwizard.svg'

import {
  Title,
  TruncateAndTooltip,
  Flex,
  Link,
  FlexItem
} from 'mailup-web-components'

import styled from '@emotion/styled'
import { modalAIAssistant } from 'Components/ModalAiAssistantBee/recoil/state/modal'
import {
  STORE_KEY_ACCOUNT,
  evalCondition,
  storeGet
} from 'mailup-react-helpers'
import { useIntl } from 'react-intl'
import { openAIState } from '../recoil/state/editor'

const StyledImgAI = styled.img`
  position: relative;
  top: -3px;
  margin-right: 4px;
`

const StyledHeader = styled.div`
  position: relative;
  width: 100%;
  height: 60px;
  padding: 10px;
  background: var(--pure-white);
  border-bottom: 1px solid var(--silver);
`

const StyledLink = styled(Link)`
  margin-right: 8px;
  white-space: nowrap;
`

const Header = () => {
  const intl = useIntl()
  const { title } = useRecoilValue(pageState)
  const [redirectUrl] = useRedirectorUrl()
  const setModalAIAssistant = useSetRecoilState(modalAIAssistant)
  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const { loaded } = useRecoilValue(openAIState)
  useEffect(() => {
    notifyParent('selectMenuItemReact', ['EmailTemplateBeeEdit', redirectUrl])
  }, [redirectUrl])

  const beeAIAssistantEnabled = evalCondition('co:BEEMSGAIASSISTANT') || IsTrial

  const showModalAI = () => {
    setModalAIAssistant(prev => ({
      ...prev,
      show: true
    }))
  }

  return (
    <StyledHeader>
      <Flex justifyContent='space-between' alignItems='center'>
        <FlexItem padding='0 16px'>
          <Title data-mu-test='header-template-title'>
            <TruncateAndTooltip text={title} />
          </Title>
        </FlexItem>
        <FlexItem>
          <Flex alignItems='center' gap='8px;'>
            {beeAIAssistantEnabled && (
              <StyledLink
                variant='highlight'
                onClick={showModalAI}
                disabled={!loaded}
              >
                <StyledImgAI src={aiIcon} />
                {intl.formatMessage({
                  id: 'Load.Bee.UpsellModalLink'
                })}
              </StyledLink>
            )}
            <SaveTemplateButton />
          </Flex>
        </FlexItem>
      </Flex>
    </StyledHeader>
  )
}

export default Header
